export default __webpack_public_path__ + "static/media/logo.65c93f34.png";